// DeviceTabsSelect.js — Select con tabs Móvil / Tablet / Escritorio.
// Stored value: object { mobile, tablet, desktop } o un string (backwards compat).
import React, { useState } from 'react';
import styled from 'styled-components';

const Wrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
`;

const Tabs = styled.div`
  display: flex;
  gap: 0.15rem;
`;

const Tab = styled.button`
  padding: 0.2rem 0.55rem;
  background: ${p => p.$active ? '#0f355b' : '#f1f5f9'};
  color: ${p => p.$active ? '#fff' : '#475569'};
  border: 1px solid ${p => p.$active ? '#0f355b' : '#e2e8f0'};
  border-bottom: none;
  border-radius: 4px 4px 0 0;
  font-size: 0.7rem;
  cursor: pointer;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  display: flex;
  align-items: center;
  gap: 0.25rem;
`;

const StyledSelect = styled.select`
  padding: 0.4rem 0.6rem;
  border: 1px solid #e2e8f0;
  border-radius: 0 6px 6px 6px;
  font-size: 0.82rem;
  width: 100%;
  background: #fff;
  &:focus { outline: none; border-color: #14b6cb; }
`;

const TABS = [
  { key: 'mobile',  label: '📱 Móvil' },
  { key: 'tablet',  label: '📲 Tablet' },
  { key: 'desktop', label: '🖥 Escritorio' },
];

const DeviceTabsSelect = ({ value, onChange, options, fallback = '' }) => {
  // value puede ser:
  //   string (legacy) -> aplica a desktop, mobile y tablet caen a fallback
  //   object {mobile,tablet,desktop} -> moderno
  const isObj = value && typeof value === 'object' && !Array.isArray(value);
  const obj = isObj
    ? value
    : (typeof value === 'string' && value ? { desktop: value, tablet: value, mobile: value } : {});
  const [tab, setTab] = useState('desktop');

  const handle = (val) => {
    const next = { ...obj, [tab]: val };
    onChange(next);
  };

  const currentVal = obj[tab] != null ? obj[tab] : '';

  return (
    <Wrap>
      <Tabs>
        {TABS.map(t => (
          <Tab
            key={t.key}
            type="button"
            $active={tab === t.key}
            onClick={() => setTab(t.key)}
            title={`Valor para ${t.label}`}
          >
            {t.label}
            {obj[t.key] && obj[t.key] !== fallback && <span style={{ color: tab === t.key ? '#14b6cb' : '#22c55e', fontSize: '0.6rem' }}>●</span>}
          </Tab>
        ))}
      </Tabs>
      <StyledSelect value={currentVal} onChange={e => handle(e.target.value)}>
        {options.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
      </StyledSelect>
    </Wrap>
  );
};

export default DeviceTabsSelect;

// Helper para resolver el valor por device — recibe { mobile, tablet, desktop } y
// el screen width. Devuelve el valor final priorizando: device específico > desktop > fallback.
export const resolveDeviceValue = (val, fallback = '') => {
  if (val == null) return { mobile: fallback, tablet: fallback, desktop: fallback };
  if (typeof val === 'string') return { mobile: val || fallback, tablet: val || fallback, desktop: val || fallback };
  if (typeof val === 'object') {
    const desk = val.desktop || fallback;
    return {
      mobile:  val.mobile  || desk,
      tablet:  val.tablet  || desk,
      desktop: desk,
    };
  }
  return { mobile: fallback, tablet: fallback, desktop: fallback };
};
